import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type SchoolsCountriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SchoolsCountriesQuery = { __typename?: 'Query', schoolsCountries?: Array<{ __typename?: 'schoolsCountry', full_name_english?: string | null | undefined, full_name_locale?: string | null | undefined, three_letter_abbreviation?: string | null | undefined, two_letter_abbreviation?: string | null | undefined } | null | undefined> | null | undefined };


export const SchoolsCountriesDocument = gql`
    query SchoolsCountries {
  schoolsCountries {
    full_name_english
    full_name_locale
    three_letter_abbreviation
    two_letter_abbreviation
  }
}
    `;

/**
 * __useSchoolsCountriesQuery__
 *
 * To run a query within a React component, call `useSchoolsCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolsCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolsCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSchoolsCountriesQuery(baseOptions?: Apollo.QueryHookOptions<SchoolsCountriesQuery, SchoolsCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolsCountriesQuery, SchoolsCountriesQueryVariables>(SchoolsCountriesDocument, options);
      }
export function useSchoolsCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolsCountriesQuery, SchoolsCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolsCountriesQuery, SchoolsCountriesQueryVariables>(SchoolsCountriesDocument, options);
        }
export type SchoolsCountriesQueryHookResult = ReturnType<typeof useSchoolsCountriesQuery>;
export type SchoolsCountriesLazyQueryHookResult = ReturnType<typeof useSchoolsCountriesLazyQuery>;
export type SchoolsCountriesQueryResult = Apollo.QueryResult<SchoolsCountriesQuery, SchoolsCountriesQueryVariables>;